module.exports = __webpack_public_path__ + "static/media/appstore.8c15379d.svg";